import clsx from 'clsx';
import Structure from 'components/REDL/Structure';
import styles from './blocredl.module.scss';
import __isEmpty from 'lodash/isEmpty';
import ContainerBloc from '../Components/ContainerBloc/ContainerBlocComponent';
import ErrorBoundary from 'components/3catinfo/ErrorBoundary';
import { useRouter } from 'next/router';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useEffect, useState } from 'react';
import { useDelivertyUser } from 'hooks/useDelivertyUser';
import { useRedl } from 'hooks/useRedl';

// necessari per REDL
export default function BlocREDL(props) {
    const { isEditModeEnable: isEditMode } = useDelivertyUser();
    const { hidePreview } = useRedl();
    const isEditModeEnable = isEditMode && !hidePreview;
    const { blocIdx, estil, ultimBloc, structure, tipus, className } = props;
    const blocRedlUid = isEditModeEnable ? `blocredl-${blocIdx}` : undefined;

    const router = useRouter();
    const { redlParamId, redlParamTipologia } = useRedlMetadata(router.pathname, router.query);
    const [hasRedlParamId, setHasRedlParamId] = useState(false);
    const [hasRedlParamTipologia, setHasRedlParamTipologia] = useState(false);
    const [structureProps, setStructureProps] = useState(props);

    useEffect(() => {
        // Cal iterar 'structure' [{...}], un array d'objectes amb { children: [{...}], finalProps: {...} },
        // en què 'children' torna a ser un array d'objectes amb { children: [{...}], finalProps: {...} }.
        // Si algun 'finalProps' conté les propietats id === redlParamId i/o tipologia === redlParamTipologia,
        // caldrà activar 'hasRedlParamId' i/o 'hasRedlParamTipologia' convenientment.
        // Ho farem amb funcions recursives perquè no sabem quina serà la profunditat de l'estructura, i l'hem d'iterar tota.
        const findRedlParamsInItems = (items, redlParamId, redlParamTipologia) => {
            items.forEach((item) => {
                const { id, tipologia } = item;
                if (!!redlParamId && !!redlParamTipologia) {
                    if (id && tipologia && id.toString() === redlParamId && tipologia === redlParamTipologia) {
                        setHasRedlParamId(true);
                        setHasRedlParamTipologia(true);
                        item.redlAuxState = { isRedlId: true, isRedlTipologia: true };
                    }
                } else if (!!redlParamId) {
                    if (id && id.toString() === redlParamId) {
                        setHasRedlParamId(true);
                        item.redlAuxState = { isRedlId: true };
                    }
                } else if (!!redlParamTipologia) {
                    if (tipologia && tipologia === redlParamTipologia) {
                        setHasRedlParamTipologia(true);
                        item.redlAuxState = { isRedlTipologia: true };
                    }
                }
            });
        };
        const findRedlParamsInModules = (children, redlParamId, redlParamTipologia) => {
            if (children?.length > 0) {
                children.forEach((module) => {
                    if (module.finalProps) {
                        module.finalProps.items
                            ? findRedlParamsInItems(module.finalProps.items, redlParamId, redlParamTipologia)
                            : findRedlParamsInItems(
                                  [module.finalProps.item || module.finalProps],
                                  redlParamId,
                                  redlParamTipologia
                              );
                    }
                    if (module.children) {
                        findRedlParamsInModules(module.children, redlParamId, redlParamTipologia);
                    }
                });
            }
        };

        if (isEditModeEnable) {
            findRedlParamsInModules(structure, redlParamId, redlParamTipologia);
            setStructureProps({ ...props, structure });
        }
    }, [props, structure, isEditModeEnable, redlParamId, redlParamTipologia]);

    const stylesBloc =
        clsx(
            styles.blocREDL,
            isEditModeEnable && styles.editMode,
            (hasRedlParamId || hasRedlParamTipologia) && styles.hasRedlParams,
            estil && styles[estil],
            tipus && [tipus],
            className && [className]
        ) || undefined;

    return isEditModeEnable ? (
        <ErrorBoundary hideError={false}>
            <ContainerBloc blocRedlUid={blocRedlUid} blocIdx={blocIdx} ultimBloc={ultimBloc} stylesBloc={stylesBloc}>
                <Structure {...structureProps} />
            </ContainerBloc>
        </ErrorBoundary>
    ) : (
        <ErrorBoundary hideError={true}>
            <div id={blocRedlUid} className={stylesBloc}>
                <Structure {...props} />
            </div>
        </ErrorBoundary>
    );
}
